module.exports = __webpack_public_path__ + "img/OR.6f69d054.png";